import { useCallback, useEffect } from "react";
import { useIsMobile } from "./useIsMobile";

export const useSupport = (initialize = false) => {
  const isMobile = useIsMobile();

  const onCloseWidget = useCallback(() => {
    window?.zE("messenger", "hide");
  }, []);

  const showWidget = useCallback(() => {
    window?.zE("messenger", "show");
  }, []);

  const onInit = useCallback(() => {
    if (initialize) {
      if (isMobile) {
        window?.zE("messenger", "hide");
        window?.zE("messenger:on", "close", onCloseWidget);
      } else {
        window?.zE("messenger", "show");
        window?.zE("messenger:on", "close", showWidget);
      }
    }
  }, [initialize, isMobile, onCloseWidget, showWidget]);

  useEffect(() => {
    onInit();
  }, [onInit]);

  const openSupport = useCallback(() => {
    window?.zE("messenger", "show");
    window?.zE("messenger", "open");
  }, []);
  return { openSupport };
};
